import clsx from 'clsx';
import { Link } from './link';

type TextVariant = 'default' | 'small' | 'large';

export function Text({
  className,
  variant = 'default',
  ...props
}: React.ComponentPropsWithoutRef<'p'> & { variant?: TextVariant }) {
  return (
    <p
      data-slot="text"
      {...props}
      className={clsx(
        className,
        variant === 'default' &&
          'tw:!text-base/6 tw:!text-zinc-500 tw:sm:!text-sm/6 tw:dark:!text-zinc-400',
        variant === 'small' && 'tw:!text-xs tw:!text-zinc-500 tw:dark:!text-zinc-400',
        variant === 'large' && 'tw:!text-lg tw:!text-zinc-500 tw:dark:!text-zinc-400'
      )}
    />
  );
}

export function TextLink({ className, ...props }: React.ComponentPropsWithoutRef<typeof Link>) {
  return (
    <Link
      {...props}
      className={clsx(
        className,
        'tw:text-zinc-950 tw:underline tw:decoration-zinc-950/50 tw:data-[hover]:decoration-zinc-950 tw:dark:text-white tw:dark:decoration-white/50 tw:dark:data-[hover]:decoration-white'
      )}
    />
  );
}

export function Strong({ className, ...props }: React.ComponentPropsWithoutRef<'strong'>) {
  return (
    <strong
      {...props}
      className={clsx(className, 'tw:font-medium tw:text-zinc-950 tw:dark:text-white')}
    />
  );
}

export function Code({ className, ...props }: React.ComponentPropsWithoutRef<'code'>) {
  return (
    <code
      {...props}
      className={clsx(
        className,
        'tw:rounded tw:border tw:border-zinc-950/10 tw:bg-zinc-950/[2.5%] tw:px-0.5 tw:text-sm tw:font-medium tw:text-zinc-950 tw:sm:!text-[0.8125rem] tw:dark:border-white/20 tw:dark:bg-white/5 tw:dark:text-white'
      )}
    />
  );
}
